import React from 'react'
import { node } from 'prop-types'
import CMSContext from './CMSContext'
import useCMSRequest from '../hooks/useCMSRequest'

CMSContextProvider.propTypes = {
  children: node
}

function CMSContextProvider({ children }) {
  const contentTypesResponse = useCMSRequest('/content_types', null)
  return <CMSContext.Provider value={{ contentTypesResponse }}>{children}</CMSContext.Provider>
}

export default CMSContextProvider
